module.exports = __webpack_public_path__ + "img/close-green.24812752.svg";